export default __webpack_public_path__ + "static/media/backArrow.7242bdeb.svg";